import { FaqSchemaItem, toFaqList } from '../../builders/faq'

export const designSystemFaqItems: FaqSchemaItem[] = [
  {
    question: 'コストをかけずにやる方法はありますか？',
    answer:
      '既存のUIライブラリをカスタマイズして活用するなど、コンパクトに始める方法があります。プロジェクトの範囲と深さは状況に応じて変わりますので、お気軽にご相談ください。',
  },
  {
    question: 'コンポーネントライブラリはどのような形式で納品されますか？',
    answer: '弊社が実装の場合、JavaScriptフレームワークはReactとなります。デザインファイルはFigmaを基本としています。',
  },
  {
    question: '社内にデザイナーがほとんどいないのですが大丈夫ですか？',
    answer:
      'デザインシステムの運用にはデザイナーが必要ですが、プロダクトの更新頻度や運用体制に合わせた規模のご提案が可能です。また、ご希望に応じて現在の体制でも自走できるよう内製化支援も行っています。',
  },
  {
    question: 'ネイティブアプリのデザインシステムは作成可能ですか？',
    answer:
      'ネイティブアプリにはHuman Interface GuidelineやMaterial Designといったプラットフォーマーのデザインシステムが存在しています。基本的にはプラットフォームごとのデザインシステムに準拠するか、範囲を限定して作成することをおすすめしています。',
  },
  {
    question: 'AIリーダブルなドキュメントとは何ですか？',
    answer:
      'AIリーダブルなドキュメントとは、AIツールがドキュメントの内容を正確に理解し、効率的に処理できるよう、構造化された形式で作成されたドキュメントです。これにより、コンポーネントの自動生成やデザイン提案の精度向上、ドキュメントの検索性向上、新規メンバーの学習効率改善など、デザインシステムの運用や開発においてAIツールを活用した業務効率や一貫性の向上が期待できます。将来的なAIとの協業を見据えた設計としても重要な要素となっています。',
  },
]

export const designSystemFaqList = toFaqList(
  'よくあるご質問',
  'デザインシステムに関するよくあるご質問にお答えします',
  designSystemFaqItems,
)
